import React, { useContext } from 'react';

import { Modal, ModalDialogProps } from '@eika/modal';

import CardControlContext from '@/context/card-control/CardControlContext';
import { useCard } from '@/react-query/hooks/query/use-card';

import useText from '@hooks/use-text';
import { isAdultCard, isChildCard } from '@utils/card-type-utils';

export enum SettingInfo {
    SpendingLimits = 'SpendingLimits',
    SpendingLimitsEcommerce = 'SpendingLimitsEcommerce',
    Ecommerce = 'Ecommerce',
    RegionBlock = 'RegionBlock',
}

const SpendingLimitsInfoModal = (props: ModalDialogProps) => {
    const { data: card } = useCard();
    const text = useText();
    const description =
        card && isAdultCard(card) ? text.spendingLimitsInfoContentAdultCard : text.spendingLimitsInfoContent;

    return (
        <Modal id="spending-limits-info" title={text.spendingLimitsInfoTitle} shouldCloseOnOverlayClick {...props}>
            <p>{description}</p>
        </Modal>
    );
};

const SpendingLimitsEcommerceInfoModal = (props: ModalDialogProps) => {
    const { data: card } = useCard();
    const text = useText();
    const description =
        card && isAdultCard(card) ? text.spendingLimitsInfoAppContentAdultCard : text.spendingLimitsInfoAppContent;

    return (
        <Modal
            id="spending-limits-ecommerce-info"
            title={text.spendingLimitsInfoAppTitle}
            shouldCloseOnOverlayClick
            {...props}
        >
            <p>{description}</p>
        </Modal>
    );
};

const EcommerceInfoModal = (props: ModalDialogProps) => {
    const { data: card } = useCard();
    const text = useText();

    const description = card && isChildCard(card) ? text.spendingLimitsInfoEcommerceChild : text.ecommerceText;

    return (
        <Modal id="ecommerce-info" title={text.cardControlEcommerceInfoTitle} shouldCloseOnOverlayClick {...props}>
            <p>{description}</p>
        </Modal>
    );
};

const RegionBlockInfoModal = (props: ModalDialogProps) => {
    const text = useText();
    return (
        <Modal id="ecommerce-info" title={text.regionBlockInfoTitle} shouldCloseOnOverlayClick {...props}>
            <p>{text.regionBlockInfoContent}</p>
        </Modal>
    );
};

const InfoModal = () => {
    const { selectedInfoModal, closeInfoModal } = useContext(CardControlContext);

    return (
        <>
            <SpendingLimitsInfoModal
                open={selectedInfoModal === SettingInfo.SpendingLimits}
                setOpen={() => closeInfoModal()}
                onClose={closeInfoModal}
            />
            <SpendingLimitsEcommerceInfoModal
                open={selectedInfoModal === SettingInfo.SpendingLimitsEcommerce}
                setOpen={() => closeInfoModal()}
                onClose={closeInfoModal}
            />
            <EcommerceInfoModal
                open={selectedInfoModal === SettingInfo.Ecommerce}
                setOpen={() => closeInfoModal()}
                onClose={closeInfoModal}
            />
            <RegionBlockInfoModal
                open={selectedInfoModal === SettingInfo.RegionBlock}
                setOpen={() => closeInfoModal()}
                onClose={closeInfoModal}
            />
        </>
    );
};

export default InfoModal;
